'use client';
import { JumboCard } from 'themes/jumbo/@jumbo/components';
import { Div } from 'themes/jumbo/@jumbo/shared';
import { Grid2 as Grid, Typography, Button, ListItemIcon, styled, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import {Customer, CustomerType} from './components/Customer';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import './style.css';
import { useSelector } from 'react-redux';
import { trackEvent } from "components/Tracking";

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 80,
  height: 80,
  width: 80,
  alignItems: "center",
  justifyContent: "center",
  border: `none}`,
}));

const ActiveUsersCard = () => {
  const { ipn_qty, teams } = useSelector((state: any) => state.auth.data);

  const users: CustomerType[] = teams.reduce((users:CustomerType[], email:string, currentIndex: number ) => ([
    ...users,
    {
      id: currentIndex + 1,
      email
    }
  ]), []);
  return (
    <JumboCard contentWrapper contentSx={{ p: 3 }}>
      <Grid container spacing={3.75} className="mainGrid">
        <Grid  size={{ xs:6}}>
          <Div sx={{ display: 'flex', flexDirection: 'column', height: '70px' }}>
            <Div sx={{ flex: 1 }} className='blockTitle'>
              <Typography color={'text.primary'} variant={'h6'} mb={0}>
                Active Users
              </Typography>
            </Div>
            <Div sx={{ alignContent: 'center' }} className="usersAvatar">
              <Customer customers={users} />
            </Div>
          </Div>
        </Grid>
        {/*<Grid  size={{ xs:3}}>
          <StyledListItemIcon>
            <GroupAddOutlinedIcon fontSize={"inherit"} />
          </StyledListItemIcon>
        </Grid>*/}
        <Grid  size={{ xs:6}}>
          <Div sx={{ display: 'flex', height: '100%', flexDirection: 'column', justifyContent: 'flex-end' }} className='xsReverse'>
            <Div sx={{flex: 1, textAlign: 'right' }}>
                <Tooltip title="Manage Team" placement="top" arrow>
                  <Button
                    size={'small'}
                    variant={'outlined'}
                    component={Link} 
                    to="/profile/team"
                    onClick={(ev: any) => {
                        trackEvent("Dashboard", "Users", "Manage")
                    }}
                  >
                    Manage
                  </Button>
                </Tooltip>
            </Div>
            <Div sx={{ marginLeft: 'auto', display: 'flex', gap: '0px', flexDirection: 'column', alignItems: 'center'}} className='inlineTitle'>
              <Div sx={{display: 'flex', gap: '2px', alignItems: 'center'}}>
                <Typography color={'text.primary'} variant={'h3'} mb={0}>
                  {users.length}
                </Typography>
                <Typography color={'text.secondary'} variant={'h6'} mb={0}>
                  /
                </Typography>
                <Typography color={'text.secondary'} variant={'h5'} mb={0}>
                  { ipn_qty }
                </Typography>
                <Typography color={'text.secondary'} variant={'h6'} mb={0}>
                  {`Member(s)`}
                </Typography>
              </Div>
            </Div>
          </Div>
        </Grid>
      </Grid>
    </JumboCard>
  );
};

export { ActiveUsersCard };
